export default "__VITE_ASSET__i0$oAvaB__"